exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dateFormatSelect[data-v-ac60fa52]{\n  width:fit-content;\n  display: inline !important;\n}\n", ""]);

// exports
